var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"grid grid--container"},[_c('p',{staticClass:"footer__copyright"},[_vm._v("\n      Copyright "+_vm._s(new Date().getFullYear())+" Campsite.bio\n    ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }